// REVIEW accepts javascript date object and returns MM/DD/YYYY
const dateFormat = function (date) {
	return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
}

export default dateFormat
